import React, { useMemo } from "react";
import "./Heatmap.css";
import { getSortedValuesForColumn, assignColorsToColumn } from "./colorUtils";

// const required_metrics = {
//   IQ_TOTAL_REV: "Total Revenue",
//   IQ_GP: "Gross Profit",
//   IQ_EBITDA: "EBITDA",
//   IQ_EBIT: "EBIT",
//   IQ_NI: "Net Income",
//   IQ_BASIC_EPS_INCL: "EPS",
//   IQ_TOTAL_ASSETS: "Total Assets",
//   // IQ_TOTAL_CAP: "Total Cap",
// };

// export default function Heatmap({ competitors, financials }) {
export default function Heatmap({
  competitors,
  financials,
  required_metrics = [],
  METRICS_WITH_NAMES = {},
}) {
  /** ---------------------------------------------------------
   *  Build table data: company + metric values
   * --------------------------------------------------------- */
  const tableData = useMemo(() => {
    if (!competitors?.length || !financials?.length) return [];

    return competitors
      .map((comp) => {
        const f = financials?.find((x) => x.vendor_company_id === comp.value);
        if (!f) return null;

        // const metricMap = {};
        // f.metrics.forEach((metricBlock) => {
        //   // if (!Object.keys(required_metrics).includes(metricBlock?.metric))
        //   if (!required_metrics.includes(metricBlock?.metric)) return;

        //   // metricMap[metricBlock.metric] = metricBlock?.value
        //   //   ? Number(metricBlock.value).toLocaleString("en-US", {
        //   //       // minimumFractionDigits: 2,
        //   //       maximumFractionDigits: 2,
        //   //     })
        //   //   : null;
        //   // metricMap[metricBlock.metric] = metricBlock?.value
        //   //   ? (Number(metricBlock.value) / 1e9).toLocaleString("en-US", {
        //   //       maximumFractionDigits: 2,
        //   //     }) + "B"
        //   //   : null;

        //   metricMap[metricBlock.metric] =
        //     metricBlock?.value != null
        //       ? Number(metricBlock.value).toLocaleString("en-US", {
        //           maximumFractionDigits: 2,
        //         }) + "B"
        //       : null;
        // });

        // return {
        //   company_name: comp.label,
        //   vendor_company_id: comp.value,
        //   financials: metricMap,
        // };
        const metricMap = {}; // formatted display values
        const rawMap = {}; // raw numeric values for color calculation

        f.metrics.forEach((metricBlock) => {
          if (!required_metrics.includes(metricBlock?.metric)) return;
          const num =
            metricBlock?.value != null ? Number(metricBlock.value) : null;
          metricMap[metricBlock.metric] =
            num != null
              ? // ? num.toLocaleString("en-US", { maximumFractionDigits: 2 }) + "B"
                num.toLocaleString("en-US", { maximumFractionDigits: 2 })
              : null;
          rawMap[metricBlock.metric] = num;
        });

        return {
          company_name: comp.label,
          vendor_company_id: comp.value,
          financials: metricMap,
          rawFinancials: rawMap, // used only for color calculation
        };
      })
      .filter(Boolean);
    // }, [competitors, financials]);
  }, [competitors, financials, required_metrics]);

  // const metrics =
  //   tableData.length > 0 ? Object.keys(tableData[0].financials) : [];
  // const metrics = Array.from(
  //   new Set(tableData.flatMap((row) => Object.keys(row.financials || {})))
  // );
  // const metrics = Object.keys(required_metrics).filter((metric) =>
  //   tableData.some(
  //     (row) =>
  //       row.financials &&
  //       Object.prototype.hasOwnProperty.call(row.financials, metric)
  //   )
  // );

  // const metrics = required_metrics.filter((metric) =>
  //   tableData.some((row) =>
  //     Object.prototype.hasOwnProperty.call(row.financials, metric)
  //   )
  // );
  const metrics = required_metrics.filter((metric) =>
    tableData.some((row) => row.financials?.[metric] !== undefined)
  );

  /** Compute colors BEFORE any conditional return */
  const metricColorMap = useMemo(() => {
    if (tableData.length === 0) return {};

    const result = {};

    metrics.forEach((metric) => {
      // const competitorsForMetric = tableData.map((row) => ({
      //   _id: row.vendor_company_id,
      //   data: [
      //     {
      //       type: metric,
      //       value: row.financials[metric],
      //     },
      //   ],
      // }));

      const competitorsForMetric = tableData.map((row) => ({
        _id: row.vendor_company_id,
        data: [{ type: metric, value: row.rawFinancials[metric] }],
      }));

      const sorted = getSortedValuesForColumn(metric, competitorsForMetric);
      const colored = assignColorsToColumn(
        metric,
        competitorsForMetric,
        sorted
      );

      const lookup = {};
      colored.forEach((entry) => {
        lookup[entry.id] = entry.color;
      });

      result[metric] = lookup;
    });

    return result;
  }, [tableData, metrics]);

  const capitalizeWords = (text = "") => {
    const lowercased = text.toLowerCase();
    return lowercased.replace(/\b[a-z]/gi, (char) => char.toUpperCase());
  };

  if (tableData.length === 0) return null;

  /** ---------------------------------------------------------
   *  Render Heatmap table
   * --------------------------------------------------------- */
  return (
    <div className="heatmap-table-wrapper">
      <div className="img-right">
        <span className="note_span">Figures in $Mn; except EPS</span>
      </div>
      {/* <table className="heatmap-table table table-striped table-bordered"> */}
      <table className="heatmap-table table table-bordered">
        <thead>
          <tr>
            <th className="new_comp_head text-left">Company Name</th>
            {metrics.map((m) => (
              <th className="new_comp_head" key={m}>
                {/* {m.replace(/IQ_|_/g, " ")} */}
                {/* {required_metrics[m] || m.replace(/IQ_|_/g, " ")} */}
                {/* {m.replace(/IQ_|_/g, " ")} */}
                {METRICS_WITH_NAMES[m] || m.replace(/IQ_|_/g, " ")}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tableData.map((row) => {
            if (!row.financials || Object.keys(row.financials).length === 0)
              return null;

            // console.log(
            //   "Row financials for company:",
            //   row.company_name,
            //   Object.values(row?.financials).every(
            //     (item) => isNaN(Number(item)) || item === null
            //   )
            // );
            // const isCompanyFinancialsNan = Object.values(row?.financials).every(
            //   (item) => isNaN(Number(item)) || item === null
            // );
            // if (isCompanyFinancialsNan) return null;

            // const hasNoValidFinancials = Object.values(row?.financials).every(
            //   (value) =>
            //     value === null ||
            //     value === "—" ||
            //     isNaN(Number(value.replace(/,/g, "")))
            // );

            const hasNoValidFinancials = Object.values(row?.financials).every(
              (value) =>
                value === null ||
                value === "—" ||
                isNaN(Number(String(value).replace(/,/g, "").replace(/B$/, "")))
            );

            if (hasNoValidFinancials) return null;

            return (
              <tr key={row.vendor_company_id} className="new_comp_tr">
                {/* <td className="new_comp_td">{row?.company_name}</td> */}
                <td className="new_comp_td">
                  {capitalizeWords(row?.company_name)}
                </td>

                {metrics.map((metric) => {
                  const value = row.financials[metric];
                  const colorClass =
                    metricColorMap[metric]?.[row.vendor_company_id] ||
                    "bg_white";
                  return (
                    <td key={metric} className={`${colorClass} new_comp_td`}>
                      {value ?? "—"}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="row m-0 p-0">
        <div className="col-md-8"> &nbsp; </div>
        <div className="col-md-4">
          <div className="img-right">
            <div className="min_max_block">
              <p className="max">Max</p>
              <p className="min">Min</p>
            </div>
            <div className="img_min_block">
              <img
                src="/img/Key-Competitors-legend1.png"
                alt="icons"
                className="compnay_image_subnav"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
